export default {
	name: 'AccessRoles',
	options: {
		schema: 'users',
		table: 'v_access_roles'
	}
};